// extracted by mini-css-extract-plugin
export default {"triangle":"KWHzvN","outer":"mCLw2R","inner":"titjCv","right":"Wa4LA2","left":"V94kq9"};